// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5918":"91e1eb13b9c4cc66","7496":"ea2c53396a658458"}[chunkId] + ".js";
};